import { createSlice } from '@reduxjs/toolkit';
const exchangeRate: any = {};
const filters: any = {};

const exchangeRateReducer = createSlice({
	name: 'exchangeRates',
	initialState: {
		isLoading: false,
		exchangeRates: [],
		exchangeRate,
		filters,
	},
	reducers: {
		setExchangeRateIsLoading: (state) => {
			state.isLoading = true;
		},
		resetExchangeRateIsLoading: (state) => {
			state.isLoading = false;
		},
		setExchangeRates: (state, action) => {
			state.exchangeRates = action.payload;
		},
		resetExchangeRates: (state) => {
			state.exchangeRates = [];
		},
		setExchangeRate: (state, action) => {
			state.exchangeRate = action.payload;
		},

		resetExchangeRate: (state) => {
			state.exchangeRate = {};
		},

		setExchangeRateFilters: (state, action) => {
			state.filters = action.payload;
		},

		resetExchangeRateFilters: (state) => {
			state.filters = {};
		},
	},
});
export const {
	setExchangeRateIsLoading,
	resetExchangeRateIsLoading,
	setExchangeRate,
	resetExchangeRate,
	setExchangeRates,
	resetExchangeRates,
	setExchangeRateFilters,
	resetExchangeRateFilters,
} = exchangeRateReducer.actions;
export default exchangeRateReducer.reducer;
